import { SubmissionError } from 'redux-form';

import request from '@utils/request';

const PREFIX = '[INQUIRY]';

export const CREATE_INQUIRY_REQUEST = `${PREFIX} CREATE_INQUIRY_REQUEST`;
export const CREATE_INQUIRY_SUCCESS = `${PREFIX} CREATE_INQUIRY_SUCCESS`;
export const CREATE_INQUIRY_FAILURE = `${PREFIX} CREATE_INQUIRY_FAILURE`;

const createInquiryRequest = () => ({
  type: CREATE_INQUIRY_REQUEST,
});

const createInquirySuccess = payload => ({
  type: CREATE_INQUIRY_SUCCESS,
  payload,
});

const createInquiryFailure = () => ({
  type: CREATE_INQUIRY_FAILURE,
});

export const createInquiry = (id, inquiry) => (dispatch) => {
  dispatch(createInquiryRequest());

  return request
    .post(`v1/cases/${id}/inquiry/`, inquiry)
    .then(({ data }) => dispatch(createInquirySuccess(data)))
    .catch((error) => {
      dispatch(createInquiryFailure());

      throw new SubmissionError(error.response.data);
    });
};

export const GET_COUNTRIES_LIST_REQUEST = `${PREFIX} GET_COUNTRIES_LIST_REQUEST`;
export const GET_COUNTRIES_LIST_SUCCESS = `${PREFIX} GET_COUNTRIES_LIST_SUCCESS`;
export const GET_COUNTRIES_LIST_FAILURE = `${PREFIX} GET_COUNTRIES_LIST_FAILURE`;

const getCountriesListRequest = () => ({
  type: GET_COUNTRIES_LIST_REQUEST,
});

const getCountriesListSuccess = payload => ({
  type: GET_COUNTRIES_LIST_SUCCESS,
  payload,
});

const getCountriesListFailure = () => ({
  type: GET_COUNTRIES_LIST_FAILURE,
});

export const getCountriesList = id => (dispatch) => {
  dispatch(getCountriesListRequest());

  return request
    .options(`v1/cases/${id}/inquiry`)
    .then(({ data }) => dispatch(getCountriesListSuccess(data.country)))
    .catch((error) => {
      dispatch(getCountriesListFailure());

      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/inquiry.js